const CONFIG_MAP = {
  prod: {
    appName: 'SDL',
    backend_url: 'https://sdl-api.musea2.azure.ext.gm.com',
    blob_storage_Url: 'https://a209240p0stapp.blob.core.windows.net/',
    auth: {
      issuer: '5de110f8-2e0f-4d45-891d-bcf2218e253d',
      clientId: 'fbf47e3e-b93e-40d1-81ad-864a067a7be9',
    },
    upload_to_folder: "home"
  },
  dev: {
    appName: 'SDL (Dev)',
    backend_url: 'https://vdl-api-dev.musea2.azure.ext.gm.com',
    blob_storage_Url: 'https://a209240d2stapp.blob.core.windows.net/',
    auth: {
      issuer: '6baa4eb1-106a-440b-b4f6-50134497d36d',
      clientId: '89f9269d-8e8c-43a8-83b3-4d66409bfa56',
    },
    upload_to_folder: "home"
  },
  local: {
    appName: 'SDL (Local)',
    backend_url: 'http://localhost:8000',
    blob_storage_Url: 'https://a209240d2stapp.blob.core.windows.net/',
    auth: {
      issuer: '6baa4eb1-106a-440b-b4f6-50134497d36d',
      clientId: '89f9269d-8e8c-43a8-83b3-4d66409bfa56',
    },
    upload_to_folder: "home"
  }
};

const getRunSpace = (url = window.location.href) => {
  let hostname;
  try {
    hostname = new URL(url).hostname;
  } catch (e) {
    hostname = url;
  }

  if (
    (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1'
  ) {
    return 'local';
  }

  if (hostname.includes('dev')) {
    return 'dev';
  }

  return 'prod';
};

const getAppSettings = (env) => {
  const config = CONFIG_MAP[env];

  const settings = {
    REACT_APP_APP_ENV: env,
    REACT_APP_TENANT_ID: config.auth.issuer || '',
    REACT_APP_CLIENT_ID: config.auth.clientId || '',
    REACT_APP_BLOB_ACCOUNT: config.blob_storage_Url || '',
    REACT_APP_API_BASE_URL: config.backend_url || '',
    REACT_APP_BLOB_UPLOAD_FLDR: config.upload_to_folder || '',
  };

  const requiredKeys = [
    'REACT_APP_TENANT_ID',
    'REACT_APP_CLIENT_ID',
    'REACT_APP_API_BASE_URL',
  ];
  requiredKeys.forEach((key) => {
    if (!settings[key]) {
      console.warn(`Warning: ${key} is not set for ${env} environment.`);
    }
  });

  return settings;
};



let settingsCache = null;

export const getSettingValue = (name) => {
  if (!settingsCache) {
    const deploymentSpace = getRunSpace();
    settingsCache = getAppSettings(deploymentSpace);
  }

  return settingsCache[name] !== undefined ? settingsCache[name] : null;
};

export const safeJoin = (value, separator = ',') => {
  if (Array.isArray(value)) {
    return value.join(separator);
  }
  if (typeof value === 'string' && value.trim() !== '') {
    return value;
  }
  return '';
};

export const hasValue = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return typeof value === 'string' && value.trim() !== '';
};

export const safeLength = (value) => {
  if (Array.isArray(value)) {
    return value.length;
  }
  return (typeof value === 'string' && value.trim() !== '') ? 1 : 0;
};

export const toArray = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    return [value];
  }
  return [];
};

export const toString = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0 ? value[0] : '';
  }
  return typeof value === 'string' ? value : '';
};

export const buildFilterParams = (filters, config = {}) => {
  const params = {};
  
  Object.entries(filters).forEach(([key, value]) => {
    const paramKey = config[key]?.paramName || key;
    const converter = config[key]?.converter;
    
    if (hasValue(value)) {
      if (converter) {
        params[paramKey] = converter(value);
      } else if (typeof value === 'string' || Array.isArray(value)) {
        params[paramKey] = safeJoin(value);
      } else {
        params[paramKey] = value;
      }
    }
  });
  
  return params;
};

export const savedownloadFiles = (files) => {
  let downloadFiles = [];
  try {
    downloadFiles = JSON.parse(sessionStorage.getItem('downloadFiles')) || [];
  } catch (e) {
    console.error('Error saving download files:', e);
    downloadFiles = [];
  }

  const normalizedFiles = Array.isArray(files) ? files : [files];

  const newFiles = normalizedFiles
    .map(file => {
      const fileLocation = file.file_location || file.file_path || file.location || file.path;
      const fileName = file.filename || file.name;
      
      if (fileName && fileLocation) {
        return {
          name: fileName,
          location: fileLocation,
        };
      }
      return null;
    })
    .filter(file => file !== null);

  if (newFiles.length === 0) {
    console.warn('No valid files to add to cart. Files must have both filename and file_location.');
    return;
  }

  const uniqueFiles = Array.from(
    new Set([...downloadFiles, ...newFiles].map(file => file.location))
  ).map(location => {
    return [...downloadFiles, ...newFiles].find(file => file.location === location);
  });

  sessionStorage.setItem('downloadFiles', JSON.stringify(uniqueFiles));
  const event = new CustomEvent('updateBadgeContent', { detail: uniqueFiles.length });
  window.dispatchEvent(event);
};

export const formatFileSize = (fileSize) => {
  if (!fileSize && fileSize !== 0) {
    return null;
  }

  let size = parseInt(fileSize, 10);
  
  if (isNaN(size)) {
    return null;
  }

  const units = ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  
  for (const unit of units) {
    if (Math.abs(size) < 1024.0) {
      return `${size.toFixed(1)} ${unit}`;
    }
    size /= 1024.0;
  }
  
  return `${size.toFixed(1)} YiB`;
};

export const parseFileSize = (fileSize) => {
  if (!fileSize && fileSize !== 0) {
    return 0;
  }
  const size = parseInt(fileSize, 10);
  return isNaN(size) ? 0 : size;
};

export const releaseNotes = {
  "version": "11",
  "releaseDate": "2026-04-28",
  "releaseLog": {
    "features": [
      {
        "feature": "DB Combiner",
        "description": "New Combiner page to search, select, and merge parasitics capture files from WiVi by date range and VIN. Includes task status tracking for processing jobs."
      },
      {
        "feature": "Files API Support",
        "description": "Added file_id, upload_source, and extra_metadata fields to the Logger model to support external file ingestion via the Files API."
      },
    ],
    "bugFixes": [
      {
        "feature": "Production Database Migration",
        "description": "Fixed missing migration causing 'column loggers.file_id does not exist' error on the SDL page."
      },
      {
        "feature": "Combiner Date Picker Crash",
        "description": "Fixed a crash when clearing the date range picker in the Combiner page."
      },
    ],
  }
};